import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { href: "/#about", label: "About" },
  { href: "/#strategy", label: "Strategy" },
  { href: "/#why-us", label: "Why Us" },
  { href: "/#guide", label: "Get the Guide" },
];

export function Logo({ light = true }) {
  const stroke = light ? "#C9A84C" : "#0A0E1A";
  const text = light ? "text-[var(--ivory)]" : "text-[var(--navy)]";
  return (
    <Link to="/" data-testid="brand-logo" className={`flex items-center gap-3 ${text}`}>
      <svg width="26" height="32" viewBox="0 0 26 32" fill="none" aria-hidden="true">
        <path d="M13 2L2 11v19h7v-9h8v9h7V11L13 2z" stroke={stroke} strokeWidth="1.4" />
        <path d="M13 2v9" stroke={stroke} strokeWidth="1.4" />
        <circle cx="13" cy="14" r="1.4" fill={stroke} />
      </svg>
      <span className="font-display text-[1.15rem] tracking-[0.18em] uppercase">
        Ascend <span className="opacity-70">Property</span>
      </span>
    </Link>
  );
}

export function Nav({ scrolled }) {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[rgba(14,23,48,0.85)] backdrop-blur-md border-b border-[rgba(201,168,76,0.18)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[0.85rem] tracking-[0.16em] uppercase hover:text-[var(--gold)] transition-colors"
              style={{ color: "#F5F0E8" }}
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:block">
          <a href="/#guide" data-testid="nav-cta" className="btn-gold-outline">
            Request the Guide
          </a>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[var(--ivory)] p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[var(--navy)] border-t border-[rgba(201,168,76,0.18)]">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[var(--ivory)]/90 tracking-[0.16em] uppercase text-sm"
              >
                {l.label}
              </a>
            ))}
            <a href="/#guide" onClick={() => setOpen(false)} className="btn-gold-outline w-fit">
              Request the Guide
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
